export default __webpack_public_path__ + "static/media/enjoy-hunt-1.44ab5481.jpg";